export class CustomerMOVSurchargeModel{
    MinOrderAmount: string;
    MaxOrderAmount: string;
    SurchargeOrderAmount: string;
    HeaderMessage: string;
    DetailMessage: string
}


// WEBPACK FOOTER //
// ./src/models/customer/customerMOVSurcharge.model.ts